import { Stack, styled, useTheme } from "@mui/material"
import { CreamIcon } from "@pharmupp/p3-front-commons"
import { FileText, ShoppingCart, Users } from "react-feather"

const MAIN_SIZE = 28
const CREAM_ICON_SIZE = 10

export const AttendanceIcons = () => {
  const {
    palette: { tertiary },
  } = useTheme()
  return <Users color={tertiary.dark2} size={MAIN_SIZE} />
}

export const AverageBasketIcons = () => {
  const {
    palette: { tertiary },
  } = useTheme()

  return (
    <IconsLayout>
      <ShoppingCart color={tertiary.dark2} size={MAIN_SIZE} />
      <Stack color={tertiary.dark4} direction="row" position="relative">
        <FileText />
        <CreamIcon style={{ position: "absolute", left: 16 }} />
      </Stack>
    </IconsLayout>
  )
}

export const AverageBasketWithoutPrescriptionIcons = () => {
  const {
    palette: { tertiary },
  } = useTheme()

  return (
    <IconsLayout>
      <ShoppingCart color={tertiary.dark2} size={MAIN_SIZE} />
      <Stack color={tertiary.dark4} direction="row" position="relative">
        {Array.from({ length: 3 }).map((_, i) => (
          <CreamIcon
            // biome-ignore lint/suspicious/noArrayIndexKey: Only for display
            key={i}
            style={{
              position: "absolute",
              left: CREAM_ICON_SIZE * i,
              top: 0,
              transform: "translateY(-50%)",
            }}
          />
        ))}
      </Stack>
    </IconsLayout>
  )
}

const IconsLayout = styled(Stack)(({ theme: { spacing } }) => ({
  flexDirection: "row",
  alignItems: "center",
  gap: spacing(1.25),
}))
